<script setup lang="ts">
  import { computed } from 'vue';
  import { RouterLink, type RouteLocationRaw } from 'vue-router';
  import { parseNoticeMessage } from './parse-notice-message';

  const props = defineProps<{
    message: string;
    label?: string | null;
    to?: RouteLocationRaw | null;
  }>();

  const emit = defineEmits<{
    (e: 'navigate'): void;
  }>();

  const parts = computed(() => parseNoticeMessage(props.message));

  const trimmedLabel = computed(() => {
    const label = props.label?.trim();
    return label && label.length > 0 ? label : null;
  });

  const isInline = computed(() => parts.value.after !== null);
</script>

<template>
  <template v-if="isInline">
    <span>{{ parts.before }}</span>
    <RouterLink
      v-if="to && trimmedLabel"
      :to="to"
      class="font-medium text-gray-07 underline decoration-1 underline-offset-2"
      @click="emit('navigate')"
    >
      {{ trimmedLabel }}
    </RouterLink>
    <span v-else-if="trimmedLabel">{{ trimmedLabel }}</span>
    <span>{{ parts.after }}</span>
  </template>
  <template v-else>
    <span>{{ `${parts.before} ` }}</span>
    <RouterLink
      v-if="to && trimmedLabel"
      :to="to"
      class="font-medium text-gray-07 underline decoration-1 underline-offset-2"
      @click="emit('navigate')"
    >
      {{ trimmedLabel }}
    </RouterLink>
  </template>
</template>
